import {createRouter, createWebHistory} from 'vue-router'
import EvatyViewComponent from "@/components/EvatyViewComponent.vue";


const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/login',
        component: () => import('@/views/auth/EvatyLoginPage.vue'),
        meta: {needsAuth: false}
    },
    {
        path: '/media',
        component: () => import('@/views/EvatyMediaPage.vue')
    },
    {
        path: '/event',
        component: EvatyViewComponent,
        children: [
            {
                path: '',
                component: () => import('@/views/event/EvatyEventPage.vue')
            },
            {
                path: 'create',
                component: () => import('@/views/event/EvatyEventCreatePage.vue')
            },
            {
                path: ':id',
                component: () => import('@/views/event/EvatyEventEditPage.vue')
            },
        ]
    },
    {
        path: '/user',
        component: EvatyViewComponent,
        children: [
            {
               path: '',
                component: () => import('@/views/user/EvatyUserOverviewPage.vue')
            },
            {
                path: ':id',
                component: () => import('@/views/user/EvatyUserEditPage.vue')
            }
        ]
    },
    {
        path: '/home',
        component: () => import('@/views/EvatyHomePage.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/home'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('user');
    if (to.meta.needsAuth === false) {
        next();
        return
    }
    if (loggedIn !== null) {
        next();
        return
    }
    next("/login");
})

export default router
